import { GUID, Param } from "app/brightserve/brightserve.module";
import { User } from "./user";

export class Annotation {
    Id: GUID;
    Author: User;
    DateCreated: Date;
    Title: string;
    Content: string;
    Type: Param;

    constructor(init?: Partial<Annotation>) {
        Object.assign(this, init);

        if (init && init.Author) {
            this.Author = new User(init.Author);
        } else {
            this.Author = null;
        };

        if (init && init.Type) {
            this.Type = new Param(init.Type);
        } else {
            this.Type = null;
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/annotation.ts